
import _find from 'lodash/find'

import moment from 'moment-timezone'

import { mapState, mapActions, mapGetters } from 'vuex'

import { getDateFromMap } from '@/helpers/dates'

import Calendar from '@/components/Calendar.vue'

import { constructNumberOfGuestsString } from '@/helpers/reservations'

const dateFormat = 'YYYY-MM-DD'

export default {
  components: {
    Calendar,
  },
  props: {
    modify: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      calendarExpanded: false,
      dateError: '',
      dateInput: '',
    }
  },
  computed: {
    ...mapState({
      merchant: state => (state as any).api.merchant,
      reservation: state => (state as any).api.reservation,
    }),
    ...mapGetters({
      numberOfGuestOptions: 'api/numberOfGuestOptionsFormatted',
      timeOptions: 'api/timeOptionsFormatted',
      defaultSelectedTimeOptionFormatted:
        'api/defaultSelectedTimeOptionFormatted',
      defaultSelectedDayFormatted: 'api/defaultSelectedDayFormatted',
    }),
    numberOfGuestsString() {
      return constructNumberOfGuestsString(
        '',
        false,
        this.merchant.guestAlternativeText
      )
    },
    dates: {
      get() {
        return this.$store.state.api.dateAvailabilityMap
      },
    },
    numberOfGuests: {
      get() {
        return this.$store.state.reservationSearch.numberOfGuests
      },
      set(numberOfGuests) {
        this.reservationSearch({ numberOfGuests })
      },
    },
    day: {
      get() {
        return this.$store.state.reservationSearch.day
      },
      set(day) {
        this.calendarExpanded = false
        this.reservationSearch({ day })
      },
    },
    time: {
      get() {
        return this.$store.state.reservationSearch.time
      },
      set(time) {
        this.reservationSearch({ time })
      },
    },
    allParametersSet() {
      return (
        this.numberOfGuests !== undefined &&
        this.day !== undefined &&
        this.time !== undefined
      )
    },
  },
  created() {
    if (!this.merchant.autoSearch) {
      return
    }
    this.ensureNumberOfGuests()
    this.ensureDay()
    this.ensureTime()
    this.dateInput = this.day?.value?.format(dateFormat)
  },
  updated() {
    if (!this.merchant.autoSearch) {
      return
    }
    this.ensureNumberOfGuests()
    this.ensureDay()
    this.ensureTime()
  },
  methods: {
    ...mapActions({
      reservationSearch: 'reservationSearch/update',
      updateReservation: 'api/updateReservation',
    }),
    handleDayClick(day) {
      this.day = day
      this.dateInput = day.value.format(dateFormat)
    },
    handleDayFocus() {
      this.calendarExpanded = true
    },
    handleDayBlur() {
      this.calendarExpanded = false
    },
    handleKeyboardDay(event) {
      const value = event.target.value
      this.dateInput = value
      const dateValidator = /^\d{4}-\d{2}-\d{2}$/
      if (dateValidator.test(value)) {
        const providedDate = moment(value, dateFormat)
        const date = getDateFromMap({ date: providedDate, map: this.dates })
        if (date?.available && !date?.passed) {
          this.dateError = ''
          this.day = date
        } else {
          this.dateError = 'This date is not available. Please select another.'
        }
      } else {
        this.dateError = 'Please enter a date in YYYY-MM-DD format'
      }
    },
    ensureTime() {
      let time = this.time

      if (!time || !_find((this as any).timeOptions, { label: time.label })) {
        time = this.modify
          ? this.reservation.time
          : this.defaultSelectedTimeOptionFormatted

        this.reservationSearch({ time })
      }
    },
    ensureDay() {
      let day = this.day

      if (!day) {
        day = this.modify
          ? this.reservation.day
          : this.defaultSelectedDayFormatted

        this.reservationSearch({ day })
      }
    },
    ensureNumberOfGuests() {
      let numberOfGuests = this.numberOfGuests

      if (
        !numberOfGuests ||
        !_find((this as any).numberOfGuestOptions, {
          value: numberOfGuests.value,
          label: numberOfGuests.label,
        })
      ) {
        numberOfGuests =
          (this as any).numberOfGuestOptions[1] ||
          (this as any).numberOfGuestOptions[0] // TODO: use merchant configuration instead?

        if (numberOfGuests.label.match(/\+/)) {
          numberOfGuests = (this as any).numberOfGuestOptions[0]
        }

        numberOfGuests = this.modify
          ? this.reservation.numberOfGuests
          : numberOfGuests

        this.reservationSearch({ numberOfGuests })
      }
    },
  },
}
